import React, { useState, useContext, FC, Key, useEffect } from "react"
import { Link } from "react-router-dom"
import { Table } from "antd"
import type { ColumnsType } from "antd/es/table"
import { UserOutlined, MoreOutlined } from "@ant-design/icons"
import type { MenuProps } from "antd"
import { Dropdown, Space } from "antd"
import { SidebarContext, isAuth } from "../../../auth/ProtectedRoute"
import { UserMessageDataType } from "../types/DataType"
import axios from "axios"
import moment from "moment"
import SkeletonTable, { SkeletonTableColumnsType } from "../../../../components/SkeletonTable"
import parse from "html-react-parser"
import { CircularProgress, Box } from "@mui/material";


const SupportMessageTable: FC = () => {
  const { userName, sidebarData } = useContext(SidebarContext)
  const [loading, setLoading] = useState<boolean>(false)
  const [userMessageData, setUserMessageData] = useState<UserMessageDataType[]>([])
  const [showTotal, setShowTotal] = useState<number>()
  const [record, setRecord] = useState<UserMessageDataType>()
  const [selectedRowKeys, setSelectedRowKeys] = useState<Key[]>([])

  const showAllUserMessageTable = async (page: number) => {
    setLoading(true)
    try {
      const response = await axios({
        method: "GET",
        url: process.env.REACT_APP_HOST_API + `manage-support-messages/all/conversations?page=${page}`,
        headers: {
          Authorization: `Bearer ${isAuth()}`,
        },
      })
      console.log("response.data", response.data)
      // Ensure each item has a unique key
      const dataWithKeys = response.data?.message.map((item: UserMessageDataType) => ({
        ...item,
        key: item.id, // Assuming each message has an id field
      }))

      setUserMessageData(dataWithKeys)
      setShowTotal(response.data?.message?.length || 0)
    } catch (err) {
      console.log(err)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    showAllUserMessageTable(1)
  }, [])

  const items: MenuProps["items"] = [
    {
      label: (
        <Link
          to={`user-reply?ref=${record?.id}`}
          state={{ userName: userName, sidebar: sidebarData }}
        >
          Reply
        </Link>
      ),
      key: "1",
      icon: <UserOutlined />,
    },
  ]

  const columns: ColumnsType<UserMessageDataType> = [
    {
      title: "Title",
      dataIndex: "title",
      render: title => parse(title.slice(0, 25)),
    },
    {
      title: "Message Body",
      dataIndex: "body",
      render: body => parse(body.slice(0, 40)),
    },
    {
      title: "Sent By",
      dataIndex: "sent_by",
      render: (text) => (
        <div className="user-area" style={{ alignItems: "center", display: "flex" }}>
          <div
            style={{
              width: "45px",
              height: "45px",
              borderRadius: "50%",
              backgroundColor: "#4895ef",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "#fff",
              fontWeight: 600,
              fontSize: "16px",
              marginRight: "20px",
              flexShrink: 0,
            }}
          >
            {text?.charAt(0)?.toUpperCase() || "?"}
          </div>
          <p className="user_name" style={{ margin: 0, fontWeight: 500 }}>
            {text}
          </p>
        </div>
      ),
    },
    {
      title: "Date",
      dataIndex: "created_at",
      render: created_at => moment.utc(created_at).local().format("MM/DD/YYYY"),
    },
    {
      title: "Action",
      dataIndex: "action",
      render: () => (
        <div>
          <Space wrap>
            <Dropdown.Button
              menu={{ items }}
              placement="bottomCenter"
              icon={<MoreOutlined />}
              trigger={["click"]}
            />
          </Space>
        </div>
      ),
    },
  ]

  // const rowSelection = {
  //   selectedRowKeys,
  //   onChange: (selectedKeys: Key[], selectedRows: UserMessageDataType[]) => {
  //     setSelectedRowKeys(selectedKeys)
  //     console.log(`selectedRowKeys: ${selectedKeys}`, "selectedRows: ", selectedRows)
  //   },
  //   getCheckboxProps: (record: UserMessageDataType) => ({
  //     disabled: record.title === "Disabled User",
  //     name: record.title,
  //   }),
  // }

  return (
    <div className="task-dashboard" style={{ padding: "40px" }}>
      <div className="project-table">
        <SkeletonTable loading={loading} columns={columns as SkeletonTableColumnsType[]}>
          {loading ? (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "200px" }}>
              <CircularProgress size={40} thickness={4} style={{ color: "#4895ef" }} />
            </Box>
          ) : (
          <Table
              rowKey={record => record.id} // Explicitly set the rowKey
              columns={columns}
              dataSource={userMessageData}
              pagination={{
                showSizeChanger: false,
                pageSize: 20,
                total: showTotal,
                onChange: showAllUserMessageTable,
                showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
              }}
              onRow={record => ({
                onClick: () => setRecord(record),
              })}
            />
          )}
        </SkeletonTable>
      </div>
    </div>
  )
}

export default SupportMessageTable
